export interface PaymentDetails {
    sortcode: string;
    accountNumber: string;
    bankName: string;
    rollNumber: string;
    accountHolder: string;
    accountType: boolean;
}